<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
    <div class="clients">
        <loading-component>
            <template #content>
                <div class="flex flex-col gap-4">
                    <div class="self-end">
                        <button-component
                            fa-icon="fa-regular fa-plus"
                            background-color="bg-green-600"
                            @click="$router.push(`/clients/create`)"
                        >
                        </button-component>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        <card-component v-for="(client, index) of clientsStore.clients" v-bind:key="index">
                            <template v-slot:body>
                                <div class="flex flex-row gap-4 items-center break-all">
                                    <div class="flex flex-col">
                                        <h2 class="card-title">{{ client.name }}</h2>

                                        <div class="flex flex-col text-gray-400 text-sm">
                                            <div>ClientId: {{ client.client_id }}</div>
                                            <div>Type: {{ client.client_type.name }}</div>
                                            <div>Beschreibung: {{ client.description }}</div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:footer>
                                <button-component
                                    fa-icon="fa-regular fa-pencil"
                                    @click="$router.push(`/clients/${client.client_id}`)"
                                />

                                <delete-component @delete="deleteClient(client.client_id)" />
                            </template>
                        </card-component>
                    </div>
                </div>
            </template>
        </loading-component>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useClientsStore } from '@/stores/clients';
import CardComponent from '@/components/CardComponent';
import LoadingComponent from '@/components/LoadingComponent';
import ButtonComponent from '@/components/ButtonComponent';
import DeleteComponent from '@/components/DeleteComponent';
import Notifications from '@auth/vue-share/utility/notifications';
import logger from '@auth/vue-share/utility/logger';

export default {
    name: 'ClientsView',
    components: { DeleteComponent, ButtonComponent, LoadingComponent, CardComponent },
    created() {
        this.clientsStore.fetchClients();
    },
    computed: {
        ...mapStores(useClientsStore)
    },
    methods: {
        deleteClient(client_id) {
            this.clientsStore
                .deleteClient(client_id)
                .then(() => {
                    Notifications.success('Client erfolgreich gelöscht');
                })
                .catch((error) => {
                    Notifications.error('Client konnte nicht gelöscht werden');
                    logger.error('[CLIENT]', error);
                });
        }
    }
};
</script>

<style scoped></style>
